var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04807 13.9603C6.04807 9.37933 9.76187 5.66553 14.3428 5.66553C16.6223 5.66553 18.687 6.58656 20.1861 8.07551L20.1877 8.07473C20.1877 8.07473 23 10.3433 23 14.5672C23 18.7904 19.4448 23.3346 14.3428 23.3346H5.05127C4.99658 23.3346 4.98565 23.3182 5.01846 23.2854C5.16845 23.1369 5.64419 22.6659 6.24103 22.0691C7.10347 21.2074 7.45969 20.5426 7.45969 19.5044C7.45969 18.9154 7.27923 18.3092 7.11675 18.0357C7.11586 18.0344 7.11598 18.0321 7.1161 18.0296C7.1162 18.0277 7.1163 18.0257 7.11596 18.024C6.43867 16.8226 6.04807 15.4383 6.04807 13.9603ZM16.935 18.4286C16.9772 18.4522 17.0244 18.4644 17.0724 18.4641C17.0935 18.4646 17.1147 18.4626 17.1355 18.4582C17.2903 18.4255 17.3902 18.269 17.3586 18.1088L16.8119 15.3019L18.7067 13.3418C18.7531 13.2935 18.782 13.2302 18.7885 13.1625C18.8042 12.9997 18.6894 12.8547 18.5321 12.8384L15.833 12.5601L14.7568 10.0523C14.7279 9.98463 14.6757 9.93061 14.6103 9.90079C14.4657 9.83481 14.2967 9.90263 14.233 10.0523L13.1567 12.5601L10.4604 12.8384C10.3927 12.8448 10.3294 12.8758 10.2818 12.926C10.1712 13.0428 10.1729 13.2303 10.2858 13.3448L12.1778 15.3049L11.634 18.1088C11.6195 18.1802 11.6311 18.2547 11.6665 18.3178C11.7457 18.4593 11.9208 18.5076 12.0576 18.4256L14.4963 17.0281L16.935 18.4286Z",
    fill: "#D0D0CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedPriority);
export default __webpack_public_path__ + "static/media/closed-priority.c246f8f969622b7708896547ccc03e9e.svg";
export { ForwardRef as ReactComponent };